// library imports
import React, { FC } from "react";

// component imports
import Text from "../text/Text";

// component function
const Loading: FC = () => {
  return (
    <div>
      <Text>Loading...</Text>
    </div>
  );
};

export default Loading;
